export default __webpack_public_path__ + "static/media/checkbox_ico_on.f1d84e9d.svg";